// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_debounce
export function debounce(func, wait, immediate) {
  let timeout
  return function () {
    const context = this
    const args = arguments
    clearTimeout(timeout)
    timeout = setTimeout(function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }, wait)
    if (immediate && !timeout) func.apply(context, args)
  }
}

// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_throttle
export function throttle(func, timeFrame, trailing = true) {
  let lastTime = 0
  let timeout = null

  return function (...args) {
    const now = new Date()
    const timeDiff = now - lastTime
    if (timeDiff >= timeFrame) {
      if (timeout) {
        clearTimeout(timeout)
      }
      func(...args)
      lastTime = now
    } else {
      if (trailing) {
        timeout = setTimeout(() => func(...args), timeFrame - timeDiff)
      }
    }
  }
}
